import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import { DialogProps } from '@mui/material';
import { ReactElement } from 'react';

import { useGetPostReactionsQuery } from 'api/queries/useGetPostReactionsQuery';
import { Avatar } from 'components';

import { Dialog, CloseButton, DialogItem, DialogContainer, AuthorName } from './styled';

interface ReactionConfirmDialogProps extends DialogProps {
  onClose?: () => void;
  postId: string;
}

export function ReactionConfirmDialog({
  title,
  onClose,
  open,
  postId,
  ...otherProps
}: ReactionConfirmDialogProps): ReactElement {
  const { reactions: data } = useGetPostReactionsQuery({ postId });

  const reactions = [...data].sort(function (a, b) {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          overflow: 'hidden',
          width: '500px',
        },
      }}
      {...otherProps}
    >
      <CloseButton
        variant="text"
        startIcon={<KeyboardBackspaceRoundedIcon fontSize="large" />}
        onClick={onClose}
      >
        {title}
      </CloseButton>

      <DialogContainer>
        {reactions.map(({ user }) => (
          <DialogItem key={user.id}>
            <Avatar
              userId={user.id}
              filename={user.avatar?.small || ''}
              size="xs"
              onClick={(e) => e.stopPropagation()}
            />
            <AuthorName>
              {user.first_name} {user.last_name}
            </AuthorName>
          </DialogItem>
        ))}
      </DialogContainer>
    </Dialog>
  );
}
